import { useState, useEffect } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { toPackageName } from '@atlassian/jira-project-settings-apps-common/src/consts.tsx';
import type { PackageName } from '@atlassian/jira-project-settings-apps-common/src/types.tsx';

const PACKAGE_NAME: PackageName = toPackageName('jiraServiceDeskPortalHook');

export const getUrl = (projectKey: string, requestTypeId: number) =>
	`/secure/EditRequestType!editRequestTypeJson.jspa?projectKey=${projectKey}&rtId=${requestTypeId}`;

export type Response = {
	requestType: {
		portalId: number;
		portalUrl: string;
	};
};

export const usePortalId = ({
	projectKey,
	requestTypeId,
}: {
	projectKey: string;
	requestTypeId: number;
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [requestType, setRequestType] = useState<{ portalId: number; portalUrl?: string } | null>(
		null,
	);
	const [error, setError] = useState<unknown>(null);
	const url = getUrl(projectKey, requestTypeId);

	useEffect(() => {
		setRequestType(null);
		setError(null);
		setIsLoading(true);

		fetchJson<Response>(url)
			.then((data) => {
				setIsLoading(false);
				setRequestType(data.requestType);
				setError(null);
			})
			.catch((caughtError) => {
				setIsLoading(false);
				setRequestType(null);
				setError(caughtError);
				fireErrorAnalytics({
					error: caughtError,
					meta: {
						id: 'jsmPreviewButton.portalIdFetchError',
						packageName: PACKAGE_NAME,
						teamName: 'jsd-shield',
					},
				});
			});
	}, [setIsLoading, setError, setRequestType, url]);

	return {
		isLoading,
		portalId: requestType?.portalId,
		portalUrl: requestType?.portalUrl,
		error,
	};
};
